import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail } from 'lucide-react';
export function FooterSection() {
  return <footer className="bg-brand-dark text-white pt-16 pb-8" data-id="element-229">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-230">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-231">
          <div className="col-span-1 md:col-span-1" data-id="element-232">
            <img className="h-24 w-auto mb-6" src="https://cdn.magicpatterns.com/uploads/jbELFVU6yimTHPdBB4r5GJ/175975597_padded_logo.png" alt="Precision Pro Sprayers" data-id="element-233" />
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-234">
              Professional grade electric sprayers built for contractors who
              need reliability and speed.
            </p>
          </div>

          <div data-id="element-235">
            <h3 className="text-brand-yellow font-bold uppercase tracking-wider mb-4" data-id="element-236">
              Products
            </h3>
            <ul className="space-y-3" data-id="element-237">
              <li data-id="element-238">
                <Link to="/products/forcex-complete" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-239">
                  ForceX Complete Kit
                </Link>
              </li>
              <li data-id="element-240">
                <Link to="/products/forcex-diy" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-241">
                  ForceX DIY Kit
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-242">
            <h3 className="text-brand-yellow font-bold uppercase tracking-wider mb-4" data-id="element-243">
              Company
            </h3>
            <ul className="space-y-3" data-id="element-244">
              <li data-id="element-245">
                <Link to="/about" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-246">
                  About Us
                </Link>
              </li>
              <li data-id="element-247">
                <Link to="/warranty" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-248">
                  Warranty & Returns
                </Link>
              </li>
              <li data-id="element-249">
                <Link to="/contact" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-250">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-251">
            <h3 className="text-brand-yellow font-bold uppercase tracking-wider mb-4" data-id="element-252">
              Contact
            </h3>
            <ul className="space-y-4" data-id="element-253">
              <li className="flex items-start" data-id="element-254">
                <Phone className="h-5 w-5 text-brand-yellow mr-3 mt-0.5" data-id="element-255" />
                <span className="text-gray-300" data-id="element-256">810-818-5941</span>
              </li>
              <li className="flex items-start" data-id="element-257">
                <Mail className="h-5 w-5 text-brand-yellow mr-3 mt-0.5" data-id="element-258" />
                <span className="text-gray-300" data-id="element-259">
                  brandon@precisionprosprayers.com
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-260">
          <p className="text-gray-500 text-sm" data-id="element-261">
            © {new Date().getFullYear()} Precision Pro Sprayers. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-262">
            <Link to="/warranty" className="text-gray-500 text-sm hover:text-brand-yellow" data-id="element-263">
              Privacy Policy
            </Link>
            <Link to="/warranty" className="text-gray-500 text-sm hover:text-brand-yellow" data-id="element-264">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}